"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCatalogForm = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const LoadingButton_1 = __importDefault(require("@mui/lab/LoadingButton"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const helpers_1 = require("../../../common/helpers/helpers");
const FormFields_1 = __importDefault(require("./FormFields"));
const BookingLimitsErrorOrNotice_1 = __importDefault(require("../Booking/BookingLimitsErrorOrNotice"));
const LoaderWrapper = styled_components_1.default.div `
  position: relative;
  height: 100px;
`;
const ProductCatalogFormWrapper = styled_components_1.default.div `
  height: 100%;
  background: #fff;
  font-size: 1rem;
  position: relative;
  .MuiTextField-root {
    width: 100%;
  }
  form {
    display: flex;
    flex-direction: column;
  }
  .checkout-basket-items {
    margin-top: 15px;
  }

  .header {
    font-size: 20px;
    font-weight: 500;
  }

  .checkout-details {
    background: #fafafa;
    padding: 12px;
    border-bottom: 1px solid rgb(217, 217, 217);
    .checkout-details-label {
      font-size: 12px;
      margin: 0;
      color: rgba(0, 0, 0, 0.6);
    }
  }
`;
const FormFieldsWrapper = styled_components_1.default.div `
  overflow: auto;
  padding-top: 20px;
`;
const ErrorWrapper = styled_components_1.default.div `
  padding: 20px;
  font-size: 1rem;
  text-align: center;
`;
const BookingPrivacyHint = styled_components_1.default.div `
  white-space: pre-line;
`;
const OrderButton = styled_components_1.default.div `
  position: sticky;
  bottom: 0;
  flex-basis: 10%;
  width: calc(100% + 32px);
  margin-left: -16px;
  background: #fff;
  z-index: 10;
  padding: 16px;
  border-top: 2px solid rgba(0, 0, 0, 0.1);
`;
const TIME_UNTILE_LOCKED_REQUEST_IS_RETRIED = 5000;
const ProductCatalogForm = (props) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [isCreateShoopingCartOrder, setIsCreateShoopingCartOrder] = (0, react_1.useState)(false);
    const [disableButton, setDisableButton] = (0, react_1.useState)(false);
    const [timeSuggestions, setTimeSuggestions] = (0, react_1.useState)([]);
    const [timeSuggestionsTitle, setTimeSuggestionsTitle] = (0, react_1.useState)('');
    const [timeSuggestionsError, setTimeSuggestionsError] = (0, react_1.useState)('');
    const [timeSuggestionsHint, setTimeSuggestionsHint] = (0, react_1.useState)('');
    const [fetchingTimeSuggestions, setFetchingTimeSuggestions] = (0, react_1.useState)(true);
    const [catalogData, setCatalogData] = (0, react_1.useState)(null);
    const [shoppingCartApiError, setShoppingCartApiError] = (0, react_1.useState)('');
    const [bookingNotice, setBookingNotice] = (0, react_1.useState)('');
    const [formFields, setFormFields] = (0, react_1.useState)([]);
    const [error, setError] = (0, react_1.useState)('');
    const lockedRowTimeout = (0, react_1.useRef)(null);
    const { shoppingCartCatalogId, availabilityId, orderData, deleteItemFromBasket, showMenu, reviewOrder, currentLocale, userData, setOrderCompletedData, setOrderCompleted, activeItem, setShowProductCatalogForm, setShowDiscardShoppingCartDialog, setItemsInCart, disableStartTime, } = props;
    (0, react_1.useEffect)(() => () => {
        clearTimeout(lockedRowTimeout.current);
    }, []);
    const createShoopingCartOrder = () => {
        let order = helpers_1.Helpers.prepareBookingFields(formFields, 'order');
        if (orderData) {
            orderData.order.lineItems.map((item) => {
                if (item.productId) {
                    order = `${order}&order[line_items][][comment]=${item.comment}&order[line_items][][product_id]=${item.productId}&order[line_items][][quantity]=${item.quantity}`;
                }
                return item;
            });
        }
        setDisableButton(true);
        setIsCreateShoopingCartOrder(true);
        apiService_1.default
            .createShoopingCartOrder(props.currentLocale, props.userData.token, shoppingCartCatalogId, availabilityId, order)
            .then((data) => {
            if (data.status === 'locked_retry') {
                // eslint-disable-next-line no-use-before-define
                handleLockedRow();
            }
            else {
                if (data.fields) {
                    setFormFields(data.fields);
                }
                else {
                    setOrderCompletedData(data);
                    setOrderCompleted(true);
                    setShowProductCatalogForm(false);
                    setShowDiscardShoppingCartDialog(false);
                    setItemsInCart(false);
                    if (activeItem.type === 'activity' || activeItem.type === 'convention_activity') {
                        const activityId = '-' + activeItem.content.deeplink.split('-').pop(); // get the last part of the deeplink as an ID, see HM-5097, HM-6228
                        const evt = new CustomEvent('activityWasBooked', { detail: { activityId } });
                        window.dispatchEvent(evt);
                    }
                }
                setDisableButton(false);
                setIsCreateShoopingCartOrder(false);
            }
            const errorElement = document.querySelector('.field-error');
            if (errorElement) {
                errorElement.scrollIntoView({ behavior: 'smooth' });
            }
        })
            .catch(data => {
            if (data && data.fields) {
                setFormFields(data.fields);
            }
            const errorElement = document.querySelector('.field-error');
            if (errorElement) {
                errorElement.scrollIntoView({ behavior: 'smooth' });
            }
        });
    };
    const handleLockedRow = () => {
        lockedRowTimeout.current = setTimeout(() => {
            createShoopingCartOrder();
        }, TIME_UNTILE_LOCKED_REQUEST_IS_RETRIED);
    };
    const handleSubmit = event => {
        event.preventDefault();
        createShoopingCartOrder();
    };
    const formatDate = (date) => `${date.getFullYear()}/${date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}/${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}`;
    const formatDateAndTime = dateField => {
        if (!dateField.value) {
            const dateAndTime = dateField.placeholder.split(' ');
            const time = dateAndTime.length > 1
                ? dateAndTime[1]
                : `${helpers_1.Helpers.getHourFromDate(new Date().toString(), props.timezone).substr(0, 2)}:00`;
            return `${formatDate(new Date())} ${time}`;
        }
        if (dateField.value.split('T').length > 1) {
            return `${formatDate(new Date(dateField.value))} ${helpers_1.Helpers.getTimeFromISODate(dateField.value)}`;
        }
        return dateField.value;
    };
    const generateFetchSuggestionsParams = (initialFields = []) => {
        const fields = initialFields.length > 0 ? initialFields : formFields;
        const pax = fields.find(field => field.id === 'pax');
        const startTime = fields.find(field => field.id === 'starts_at');
        const multiArea = fields.find(field => field.type === 'area_multi_select');
        if (pax && startTime) {
            const table = fields.find(field => field.type === 'table_select');
            const area = fields.find(field => field.type === 'area_select');
            let selectedArea;
            let selectedTable;
            let multipleAreaIds = [];
            if (table) {
                selectedTable = table.value
                    ? table.options.find(option => option.label === table.value)
                    : table.options.find(option => option.selected);
            }
            if (area) {
                selectedArea = area.value
                    ? area.options.find(option => option.label === area.value)
                    : area.options.find(option => option.selected);
            }
            if (multiArea && multiArea.options) {
                multipleAreaIds = multiArea.options
                    .filter(option => option.selected)
                    .flatMap(option => Array(option.quantity || 1).fill(option.id));
            }
            return [
                currentLocale,
                userData.token,
                availabilityId,
                pax.value,
                startTime.value && startTime.value.split('T').length > 1
                    ? startTime.value
                    : helpers_1.Helpers.getISOString(formatDateAndTime(startTime)),
                selectedTable ? selectedTable.id : '',
                selectedArea ? selectedArea.id : '',
                multiArea ? multipleAreaIds : undefined,
            ].filter(param => param !== undefined);
        }
        return [];
    };
    const fetchInitialSuggestions = (fields) => __awaiter(void 0, void 0, void 0, function* () {
        const params = generateFetchSuggestionsParams(fields);
        if (params.length > 0) {
            setFetchingTimeSuggestions(true);
            const isMultiUnit = params[7] !== undefined;
            const apiCall = isMultiUnit ? apiService_1.default.getTimeSuggestionsForMultiUnit : apiService_1.default.getTimeSuggestions;
            try {
                const suggestionsData = yield apiCall(...params);
                if (suggestionsData.status === 'success') {
                    setTimeSuggestions(suggestionsData.suggestions.map(suggestion => Object.assign(suggestion, { selected: false })));
                    setTimeSuggestionsTitle(suggestionsData.texts.label);
                    setFormFields(fields.map(field => {
                        if (field.id === 'starts_at') {
                            const firstSelectedSuggestion = suggestionsData.suggestions.find(suggestion => suggestion.selected);
                            if (firstSelectedSuggestion) {
                                return Object.assign(field, {
                                    value: firstSelectedSuggestion.value,
                                });
                            }
                        }
                        return field;
                    }));
                }
                else {
                    setTimeSuggestionsError(suggestionsData.message);
                }
            }
            catch (error) {
                console.error('Error fetching time suggestions:', error);
                setTimeSuggestionsError('An error occurred while fetching time suggestions.');
            }
            finally {
                setFetchingTimeSuggestions(false);
            }
        }
        else {
            setFetchingTimeSuggestions(false);
        }
    });
    const fetchSuggestions = helpers_1.Helpers.debounce(() => {
        const params = generateFetchSuggestionsParams();
        if (params.length > 0) {
            setFetchingTimeSuggestions(true);
            const isMultiUnit = params[7] !== undefined;
            const apiCall = isMultiUnit ? apiService_1.default.getTimeSuggestionsForMultiUnit : apiService_1.default.getTimeSuggestions;
            apiCall(...params).then((suggestionsData) => {
                if (suggestionsData.status === 'success') {
                    setTimeSuggestions(suggestionsData.suggestions.map(suggestion => Object.assign(suggestion, { selected: false })));
                    setTimeSuggestionsTitle(suggestionsData.texts.label);
                    setTimeSuggestionsError('');
                    setTimeSuggestionsHint('');
                }
                else {
                    setTimeSuggestionsError(suggestionsData.message);
                    if (isMultiUnit && suggestionsData.actions && suggestionsData.actions.length > 0) {
                        setTimeSuggestionsHint(suggestionsData.actions[0].label);
                    }
                    else {
                        setTimeSuggestionsHint('');
                    }
                }
                setFetchingTimeSuggestions(false);
            });
        }
    }, 500);
    const renderOrderButton = () => {
        const shoppingCartField = formFields.find((field) => field.type === 'shopping_cart');
        const shoppingCartIsMandatory = shoppingCartField ? shoppingCartField.mandatory : false;
        let buttonText = '';
        if (orderData) {
            buttonText = orderData.texts.orderButton;
        }
        else if (catalogData) {
            buttonText = catalogData.texts.orderButtonLabel;
        }
        let isButtonDisabled;
        if (disableButton) {
            isButtonDisabled = true;
        }
        else if (shoppingCartIsMandatory) {
            isButtonDisabled = !(orderData && orderData.order.lineItems.length > 0);
        }
        else {
            isButtonDisabled = false;
        }
        return (react_1.default.createElement(OrderButton, null,
            react_1.default.createElement(LoadingButton_1.default, { loading: isCreateShoopingCartOrder, disabled: isButtonDisabled, type: "submit", fullWidth: true, variant: "contained" }, buttonText)));
    };
    const renderProductCatalogForm = () => {
        if (isLoading) {
            return (react_1.default.createElement(LoaderWrapper, null,
                react_1.default.createElement(Loader_1.default, null)));
        }
        if (error) {
            return react_1.default.createElement(ErrorWrapper, { "data-testid": "error-wrapper" }, error);
        }
        return (react_1.default.createElement("form", { onSubmit: handleSubmit, "data-testid": "form-fields-wrapper" },
            react_1.default.createElement(FormFieldsWrapper, null,
                react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 },
                    bookingNotice !== '' && (react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(BookingLimitsErrorOrNotice_1.default, { bookingMessage: bookingNotice }))),
                    react_1.default.createElement(FormFields_1.default, { activeItem: activeItem, fields: formFields, setFormFields: setFormFields, orderData: orderData, showMenu: showMenu, reviewOrder: reviewOrder, deleteItemFromBasket: deleteItemFromBasket, timeSuggestions: timeSuggestions, timeSuggestionsTitle: timeSuggestionsTitle, timeSuggestionsError: timeSuggestionsError, timeSuggestionsHint: timeSuggestionsHint, fetchingTimeSuggestions: fetchingTimeSuggestions, fetchSuggestions: fetchSuggestions, disableStartTime: disableStartTime }),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(BookingPrivacyHint, null, i18n_js_1.default.t('privacy_booking_hint'))),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement("a", { href: "https://www.hotel-mssngr.com/en/app/default/privacy", target: "_blank", rel: "noopener noreferrer" }, i18n_js_1.default.t('privacy_statement_link'))))),
            renderOrderButton()));
    };
    (0, react_1.useEffect)(() => {
        if (shoppingCartCatalogId) {
            apiService_1.default
                .getShoppingCartCatalog(props.currentLocale, props.userData.token, shoppingCartCatalogId, availabilityId)
                .then((data) => {
                if (data.status === 'success') {
                    setCatalogData(data);
                    let { fields } = data;
                    if (activeItem &&
                        activeItem.content &&
                        activeItem.content.availability &&
                        activeItem.content.availability.fields) {
                        const indexOfStartDate = fields.findIndex(field => field.id === 'starts_at');
                        if (indexOfStartDate !== -1) {
                            const alteredFields = [
                                ...fields.slice(0, indexOfStartDate),
                                activeItem.content.availability.fields[indexOfStartDate],
                                ...fields.slice(indexOfStartDate + 1),
                            ];
                            fields = alteredFields;
                        }
                    }
                    setFormFields(fields);
                    fetchInitialSuggestions(fields);
                }
                else {
                    setError(data.message);
                }
                if (data.notice) {
                    setBookingNotice(data.notice.info);
                }
                setIsLoading(false);
            })
                .catch(apiError => {
                if (apiError.status === 'error') {
                    setIsLoading(false);
                    setShoppingCartApiError(apiError.message);
                }
            });
        }
        else {
            setError('No shopping cart catalog id provided.');
            setIsLoading(false);
        }
    }, []);
    if (shoppingCartApiError !== '') {
        return react_1.default.createElement(BookingLimitsErrorOrNotice_1.default, { bookingMessage: shoppingCartApiError, isError: true });
    }
    return (react_1.default.createElement(ProductCatalogFormWrapper, { "data-testid": "product-catalog-form-wrapper", className: "product-catalog-form-wrapper" }, renderProductCatalogForm()));
};
exports.ProductCatalogForm = ProductCatalogForm;
const mapStoreToProps = store => ({
    currentLocale: store.getValue('currentLocale'),
    userData: store.getValue('userData'),
    timezone: store.getValue('timezone'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.ProductCatalogForm);
